import { useRef, useEffect, useState } from 'react';
import Carousel, { ResponsiveType } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useCommonDispatch, CommonActions } from '@wajeez-web/stores/common';

import React from 'react';

export interface SliderProps {
  children: React.ReactNode;
  customStyle?: string;
  arrows?: boolean;
  infinite?: boolean;
  itemClass?: string;
  dots?: boolean;
  responsive?: ResponsiveType;
  childrenLength?: number;
  totalItems?: number;
  initialSlide?: number;
  CustomDot?: (props: any) => JSX.Element;
  forceDesktop?: boolean;
  autoPlay?: boolean;
}

const Slider = ({
  children,
  arrows = true,
  infinite = false,
  customStyle = 'pb-10',
  itemClass,
  dots = false,
  responsive,
  childrenLength,
  totalItems,
  initialSlide = 0,
  CustomDot,
  forceDesktop = false,
  autoPlay = false,
}: SliderProps) => {
  const dispatch = useCommonDispatch();

  const carouselRef = useRef<Carousel>(null);

  useEffect(() => {
    if (carouselRef.current && totalItems) {
      carouselRef.current.setState({ totalItems });
    }
  }, [totalItems]);

  return (
    <>
      <div
        className={`${
          !forceDesktop ? 'sm:hidden flex' : 'hidden'
        } overflow-x-auto scrollbar-none px-2`}
      >
        <div className={`flex flex-nowrap flex-row space-s-3 ${customStyle}`}>
          {children}
        </div>
      </div>
      <div
        className={`${!forceDesktop && 'hidden sm:block'} w-full select-none`}
      >
        <Carousel
          beforeChange={() => {
            carouselRef.current?.setState({ isMoving: true });

            dispatch(CommonActions.setIsSliderMoving(true));
          }}
          afterChange={() => {
            carouselRef.current?.setState({ isMoving: false });

            dispatch(CommonActions.setIsSliderMoving(false));
          }}
          additionalTransfrom={0}
          arrows={arrows}
          centerMode={false}
          className=""
          containerClass={`container w-full ${customStyle}`}
          draggable
          focusOnSelect={false}
          infinite={infinite}
          itemClass={itemClass}
          keyBoardControl
          minimumTouchDrag={0}
          partialVisible={false}
          pauseOnHover={false}
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={true}
          renderDotsOutside={false}
          responsive={
            responsive || {
              desktop: {
                breakpoint: {
                  max: 3000,
                  min: 1337,
                },
                items: 7,
              },
              miniDesktop: {
                breakpoint: {
                  max: 1336,
                  min: 1024,
                },
                items: 5,
              },
              mobile: {
                breakpoint: {
                  max: 464,
                  min: 0,
                },
                items: 1,
              },
              tablet: {
                breakpoint: {
                  max: 1024,
                  min: 464,
                },
                items: 3,
              },
            }
          }
          rewind={false}
          rewindWithAnimation={false}
          rtl
          showDots={dots}
          customDot={CustomDot ? <CustomDot /> : <div></div>}
          slidesToSlide={1}
          swipeable
          ref={carouselRef}
          autoPlay={autoPlay}
        >
          {children}
        </Carousel>
      </div>
    </>
  );
};

export default Slider;

// const CarouselArrowLeft = (props: any) => {
//   const { className, style, onClick } = props;

//   return (
//     <div
//       className={className + ' !absolute !right-[1px] !z-10'}
//       style={{ ...style, display: 'block' }}
//       onClick={onClick}
//     />
//   );
// };

// const CarouselArrowRight = (props: any) => {
//   const { className, style, onClick } = props;

//   return (
//     <div
//       className={className + ' !absolute !left-[1px] !z-10'}
//       style={{ ...style, display: 'block' }}
//       onClick={onClick}
//     />
//   );
// };

// const CustomRightArrow = (props: any) => {
//   const { onClick, ...rest } = props;
//   const {
//     onMove,
//     carouselstate: { currentSlide, deviceType },
//   } = rest;
//   // onMove means if dragging or swiping in progress.
//   return (
//     <button
//       onClick={() => onClick()}
//       className="w-[30px] h-[30px] absolute top-1/2 left-0 bg-black"
//     />
//   );
// };

// const CustomLeftArrow = (props: any) => {
//   const { onClick, ...rest } = props;
//   const {
//     onMove,
//     carouselstate: { currentSlide, deviceType },
//   } = rest;
//   // onMove means if dragging or swiping in progress.
//   return (
//     <button
//       onClick={() => onClick()}
//       className="w-[30px] h-[30px] absolute top-1/2 right-0 bg-black"
//     />
//   );
// };

// const ButtonGroup = (props: any) => {
//   const { next, previous, goToSlide, childrenLength, ...rest } = props;

//   const [slideNumber, setSlideNumber] = useState(0);

//   // console.log('mohda', props);

//   const {
//     onMove,
//     carouselstate: { currentSlide },
//   } = rest;

//   // console.log('mohda', onMove);

//   return (
//     <div className="carousel-button-group absolute">
//       <button
//         className={
//           currentSlide === 0
//             ? 'disable'
//             : 'w-[30px] h-[30px] absolute top-1/2 right-0 bg-black'
//         }
//         onClick={() => previous()}
//       />
//       <button
//         onClick={() => {
//           // console.log('mohda', currentSlide);
//           console.log('mohda', slideNumber, childrenLength);

//           if (slideNumber + 1 < childrenLength - 4) {
//             goToSlide(slideNumber + 1);

//             setSlideNumber((state) => state + 1);
//           }
//         }}
//         className="w-[30px] h-[30px] absolute top-1/2 left-0 bg-black"
//       />
//       <button onClick={() => goToSlide(15)}> Go to any slide </button>
//     </div>
//   );
// };
